var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1418_8798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0852 11.7021H39.8937V13.8297H43.0852C43.6727 13.8297 44.149 14.3061 44.149 14.8936V40.4255C44.149 41.0131 43.6727 41.4894 43.0852 41.4894H6.91488C6.32735 41.4894 5.85102 41.0131 5.85102 40.4255V14.8936C5.85102 14.3061 6.32735 13.8297 6.91488 13.8297H10.1064V11.7021H6.91488C5.15228 11.7021 3.72339 13.131 3.72339 14.8936V40.4255C3.72339 42.1881 5.15228 43.617 6.91488 43.617H43.0852C44.8478 43.617 46.2766 42.1881 46.2766 40.4255V14.8936C46.2766 13.131 44.8478 11.7021 43.0852 11.7021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3192 42.5533V47.8724H19.6808V42.5533H17.5532V48.9362C17.5532 49.5238 18.0296 50.0001 18.6171 50.0001H31.383C31.9706 50.0001 32.4469 49.5238 32.4469 48.9362V42.5533H30.3192Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5745 47.8724H15.4255V50H34.5745V47.8724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.383 5.31911H18.6171C18.0296 5.31911 17.5532 5.79544 17.5532 6.38297V19.1489C17.5532 19.7365 18.0296 20.2128 18.6171 20.2128H31.383C31.9706 20.2128 32.4469 19.7365 32.4469 19.1489V6.38297C32.4468 5.79544 31.9706 5.31911 31.383 5.31911ZM30.3192 18.0851H19.6808V7.44684H30.3192V18.0851Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1277 9.57447H22.8723C22.2848 9.57447 21.8085 10.0508 21.8085 10.6383V14.8937C21.8085 15.4812 22.2848 15.9576 22.8723 15.9576H27.1277C27.7152 15.9576 28.1916 15.4812 28.1916 14.8937V10.6383C28.1916 10.0508 27.7152 9.57447 27.1277 9.57447ZM26.0638 13.8298H23.9362V11.7022H26.0638V13.8298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6808 19.1489V24.468H14.3617C12.5991 24.468 11.1702 25.8969 11.1702 27.6595V31.9149H13.2978V27.6595C13.2978 27.072 13.7741 26.5957 14.3617 26.5957H20.7446C21.3322 26.5957 21.8085 26.1193 21.8085 25.5318V19.1488H19.6808V19.1489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6383 24.4681H30.3192V19.1489H28.1915V25.5319C28.1915 26.1195 28.6679 26.5958 29.2554 26.5958H35.6384C36.2259 26.5958 36.7022 27.0721 36.7022 27.6597V31.9149H38.8299V27.6596C38.8298 25.897 37.4009 24.4681 35.6383 24.4681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0638 19.1489H23.9362V31.9149H26.0638V19.1489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8084 0H19.6808V6.38298H21.8084V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3192 0H28.1915V6.38298H30.3192V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0638 0H23.9362V6.38298H26.0638V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.766 7.44685H31.3831V9.57448H37.766V7.44685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.766 15.9575H31.3831V18.0851H37.766V15.9575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.766 11.7021H31.3831V13.8297H37.766V11.7021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6171 7.44685H12.2341V9.57448H18.6171V7.44685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6171 15.9575H12.2341V18.0851H18.6171V15.9575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6171 11.7021H12.2341V13.8297H18.6171V11.7021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 30.8511C23.2375 30.8511 21.8086 32.2799 21.8086 34.0425C21.8086 35.8051 23.2375 37.234 25.0001 37.234C26.7627 37.234 28.1916 35.8051 28.1916 34.0425C28.1916 32.2799 26.7627 30.8511 25.0001 30.8511ZM25.0001 35.1064C24.4126 35.1064 23.9362 34.6301 23.9362 34.0425C23.9362 33.455 24.4126 32.9787 25.0001 32.9787C25.5876 32.9787 26.0639 33.455 26.0639 34.0425C26.0638 34.6301 25.5876 35.1064 25.0001 35.1064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2341 30.8511C10.4715 30.8511 9.0426 32.2799 9.0426 34.0425C9.0426 35.8051 10.4715 37.234 12.2341 37.234C13.9967 37.234 15.4256 35.8051 15.4256 34.0425C15.4256 32.2799 13.9967 30.8511 12.2341 30.8511ZM12.2341 35.1064C11.6466 35.1064 11.1702 34.6301 11.1702 34.0425C11.1702 33.455 11.6466 32.9787 12.2341 32.9787C12.8216 32.9787 13.298 33.455 13.298 34.0425C13.2979 34.6301 12.8216 35.1064 12.2341 35.1064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.766 30.8511C36.0034 30.8511 34.5745 32.2799 34.5745 34.0425C34.5745 35.8051 36.0034 37.234 37.766 37.234C39.5286 37.234 40.9574 35.8051 40.9574 34.0425C40.9574 32.2799 39.5286 30.8511 37.766 30.8511ZM37.766 35.1064C37.1784 35.1064 36.7021 34.6301 36.7021 34.0425C36.7021 33.455 37.1784 32.9787 37.766 32.9787C38.3535 32.9787 38.8298 33.455 38.8298 34.0425C38.8297 34.6301 38.3535 35.1064 37.766 35.1064Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1418_8798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwr);
export default __webpack_public_path__ + "static/media/hwr.c2841109797156a8fefb319e294767c7.svg";
export { ForwardRef as ReactComponent };